var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleEmployee(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7401 16.305C13.5901 16.29 13.4101 16.29 13.2451 16.305C9.67509 16.185 6.84009 13.26 6.84009 9.66C6.84009 5.985 9.81009 3 13.5001 3C17.1751 3 20.1601 5.985 20.1601 9.66C20.1451 13.26 17.3101 16.185 13.7401 16.305Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.615 6C27.525 6 29.865 8.355 29.865 11.25C29.865 14.085 27.615 16.395 24.81 16.5C24.69 16.485 24.555 16.485 24.42 16.5",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23996 21.84C2.60996 24.27 2.60996 28.23 6.23996 30.645C10.365 33.405 17.13 33.405 21.255 30.645C24.885 28.215 24.885 24.255 21.255 21.84C17.145 19.095 10.38 19.095 6.23996 21.84Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5099 30C28.5899 29.775 29.6099 29.34 30.4499 28.695C32.7899 26.94 32.7899 24.045 30.4499 22.29C29.6249 21.66 28.6199 21.24 27.5549 21",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleEmployee);
export default __webpack_public_path__ + "static/media/module-employee.72a09293.svg";
export { ForwardRef as ReactComponent };